import {AdvertDTO} from "../advertDTO.interface";

